import { apiClient } from "./ApiClient";
import { API_URLS, STORAGE_KEYS } from "../constants";
import { StorageService } from "./StorageService";

export const AuthService = {
  login: async (username, password, rememberMe, autoLogin) => {
    try {
      const { data } = await apiClient.post(API_URLS.AUTH.LOGIN, { username, password });
      
      // Remember Me: 아이디 저장
      if (rememberMe) {
        StorageService.saveRememberedID(username);
      } else {
        StorageService.clearRememberedID();
      }

      // Auto Login: 토큰 저장 방식 결정
      StorageService.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.access, autoLogin);
      StorageService.setItem(STORAGE_KEYS.REFRESH_TOKEN, data.refresh, autoLogin);

      return true;
    } catch (error) {
      console.error("Login failed", error);
      return false;
    }
  },


  verifyAccessToken: async () => {
    const token = StorageService.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    if (!token) return false;  // 저장된 access_token이 없으면 false

    try {
      await apiClient.post(API_URLS.AUTH.VERIFY, { token });
      return true;  // 유효한 access_token이면 true 반환
    } catch (error) {
      return false;  // 유효하지 않으면 false 반환
    }
  },

  refreshAccessToken: async () => {
    const refreshToken = StorageService.getItem(STORAGE_KEYS.REFRESH_TOKEN);
    if (!refreshToken) return null;

    try {
      const { data } = await apiClient.post(API_URLS.AUTH.REFRESH, { refresh: refreshToken });
      StorageService.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.access, true);
      return data.access;
    } catch (error) {
      console.error("Token refresh failed", error);
      AuthService.logout();
      return null;
    }
  },

  autoLogin: async () => {
    const isValid = await AuthService.verifyAccessToken();
    if (isValid) return true;  // access_token이 유효하면 자동 로그인 성공

    // access_token이 만료된 경우 refresh_token으로 재발급 시도
    return await AuthService.refreshAccessToken();
  },

  logout: () => {
    StorageService.clearAuthData();
  },
};
